import styled from '@emotion/styled'

const VenueWrapper = styled('div')`
  .venue-detail-image::after {
    display: block;
    position: relative;
    background-image: linear-gradient(to left, transparent 10%, ${(props) => props.theme.c1} 100%);
    margin-top: calc(59vw / -1.7777);
    height: calc(59vw / 1.7777);
    content: '';
  }

  .description-color {
    color: ${(props) => props.theme.c4};
  }
  .description-see-more-color {
    color: ${(props) => props.theme.c3};
  }
`

export default VenueWrapper
